import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  cell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
}));

/**
 * Shared Cell component for Period Row layouts.
 * Currently used in pharmaCompanyPeriodRow. Intended for use across pharmacyPeriodRow, pharmaCompanyPeriodRow, and oriolaPeriodRow.
 */
function PeriodRowCell({ width, children }) {
  const classes = useStyles();

  return (
    <div className={classes.cell} style={{ width }}>
      {children}
    </div>
  );
}

PeriodRowCell.propTypes = {
  width: PropTypes.string,
  children: PropTypes.node,
};

PeriodRowCell.defaultProps = {
  width: "",
  children: null,
};

export default PeriodRowCell;
